import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSearchBranch = () => {
  const [loading, setLoading] = useState(true);
  const [searchBranch, setSearchBranch] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const getSearchBranch = (input = '') => {
    setLoading(true);

    axiosClient
      .get(`Product/Branch/Search?SearchTerm=${input}`)
      .then(res => {
        if (res.status === 200) {
          setSearchBranch(res.data.value);
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [getSearchBranch, loading, searchBranch];
};

export default useSearchBranch;
